export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_retire-tax-hub/artifacts/eg0ggbgu_HydenD_HorizontalLogo_Tag_Signature_s01_JN.jpg";

export const FIRM = {
  name: "Retirement Tax Consultants, LLC",
  short: "Retirement Tax Consultants",
  tagline: "We're the bridge between your CPA and CFP.",
  founder: "David Hyden",
  founderRole: "President & Founder",
  city: "McKinney, TX",
  address: "5900 S. Lake Forest Dr., Suite 300",
  cityState: "McKinney, TX",
  phone: "469-342-8889",
  phoneHref: "tel:+14693428889",
  email: "david@retirementtaxconsultants.com",
  linkedin: "https://www.linkedin.com/in/davidhyden/",
  facebook: "https://www.facebook.com/profile.php?id=100086559630301",
  calendly15: "https://calendly.com/david-hyden/15min",
  calendly60: "https://calendly.com/david-hyden/60min",
};

export const NAV_LINKS = [
  { label: "Services", to: "/services" },
  { label: "Advanced Strategies", to: "/advanced-conversion-strategies" },
  { label: "For Advisors", to: "/for-advisors" },
  { label: "Results", to: "/results" },
  { label: "About", to: "/about" },
];
